import "@mdi/font/css/materialdesignicons.min.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@/styles/global.scss"

Vue.use(Vuetify);

const options = {
  theme: {
    themes: {
      light: {
        primary: "#006fbc",
        secondary: "#444",
        accent: "#f46262"
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
};

export default new Vuetify(options);
